import React from 'react'
import { Link } from 'react-router-dom'

export default function ServiceAll() {
  return (
    <>
    <section className="servicepage-list">
        <div className="container">
            <div className="row align-items-center"> 

                <div className="col-lg-7 col-md-7">
                    <div className="servicelist-box wow animate__animated animate__slideInUp" data-wow-duration="1.2s" data-wow-delay="0.1s">
                        <h1 className="heading">Interior Design Service</h1>
                        <p>We create interiors that seamlessly blend aesthetics, functionality, and comfort, transforming everyday spaces into inviting environments that reflect your lifestyle and vision.</p>
                        <span>What’s Included</span>
                        <ul>
                            <li>Concept & Moodboards</li>
                            <li>Space Planning Layouts</li>
                            <li>Material and Color Selection</li>
                            <li>3D Renders Styling</li>
                            <li>Working Drawings</li>
                            <li>Regular Site Visits</li>
                        </ul>
                    </div>
                </div>

                <div className="col-lg-5 col-md-5">
                    <div className="servicelist-image">
                        <img src="/assets/images/service-list1.webp" loading="lazy" className="img-responsive" alt="service"/>

                        <Link to={"/interior-design-build/"} className="default-butn">
                            <span className="text">Learn More</span>
                            <div className="icon-container">
                                <div className="icon icon--left">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </div>
                                <div className="icon icon--right">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>

        </div>
    </section>

    <section className="servicepage-list">
        <div className="container">
            <div className="row align-items-center"> 

                <div className="col-lg-5 col-md-5 order-2 order-lg-1 order-md-1">
                    <div className="servicelist-image">
                        <img src="/assets/images/service-list2.webp" loading="lazy" className="img-responsive" alt="service"/>

                        <Link to={"/turnkey-interior-design-services/"} className="default-butn">
                            <span className="text">Learn More</span>
                            <div className="icon-container">
                                <div className="icon icon--left">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </div>
                                <div className="icon icon--right">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>

                <div className="col-lg-7 col-md-7 order-1 order-lg-2 order-md-2">
                    <div className="servicelist-box servicelist-left wow animate__animated animate__slideInUp" data-wow-duration="1.2s" data-wow-delay="0.1s">
                        <h2 className="heading">Turnkey Execution</h2>
                        <p>We oversee the entire project management process from design and material selection to coordination and on-site execution, ensuring smooth delivery and a fully ready space without any hassle.</p>
                        <span>What’s Included</span>
                        <ul>
                            <li>Transparent Budgeting</li>
                            <li>Material & Vendor Coordination</li>
                            <li>Execution Planning</li>
                            <li>Site Management</li>
                            <li>Quality Inspection</li>
                        </ul>
                    </div>
                </div>
            </div>

        </div>
    </section>

    <section className="servicepage-list">
        <div className="container">
            <div className="row align-items-center"> 

                <div className="col-lg-7 col-md-7">
                    <div className="servicelist-box wow animate__animated animate__slideInUp" data-wow-duration="1.2s" data-wow-delay="0.1s">
                        <h3 className="heading">Property management Service</h3>
                        <p>We handle the upkeep of your property, including inspections and home improvement, ensuring your space stays functional and worry-free with smooth daily management.</p>
                        <span>What’s Included</span>
                        <ul>
                            <li>Paperwork</li>
                            <li>Tenancy Management</li>
                            <li>Rent Management</li>
                            <li>Regular Property Inspections</li>
                            <li>Home Improvement</li>
                            <li>Tenant Coordination Support</li>
                            <li>Succession</li>
                        </ul>
                    </div>
                </div>

                <div className="col-lg-5 col-md-5">
                    <div className="servicelist-image">
                        <img src="/assets/images/service-list3.webp" loading="lazy" className="img-responsive" alt="service"/>

                        <Link to={"/top-property-management-services/"} className="default-butn">
                            <span className="text">Learn More</span>
                            <div className="icon-container">
                                <div className="icon icon--left">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </div>
                                <div className="icon icon--right">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>

        </div>
    </section>
    </>
  )
}
